import { exists } from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface Opac {
  myPageEnabled: boolean
  reserveEnabled: boolean
  password: string
  registeredDate: string
}

export function OpacFromJSON(json: any): Opac {
  return {
    myPageEnabled: exists(json, 'my_page_enabled')
      ? json.my_page_enabled
      : false,
    reserveEnabled: exists(json, 'reserve_enabled')
      ? json.reserve_enabled
      : false,
    password: exists(json, 'password') ? json.password : '',
    registeredDate: exists(json, 'registered_date')
      ? dateToPlainFormat(json.registered_date)
      : ''
  }
}

export const defaultOpac = (): Opac => ({
  myPageEnabled: true,
  reserveEnabled: true,
  password: '',
  registeredDate: ''
})
